import SurveyConfiguration from "./SurveyConfiguration";

export default SurveyConfiguration;
